<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="hasSomethingToShow"
    :class="[data.componentBaseClassName, data.componentClassName]"
  >
    <div
      v-if="regionsHtml.title"
      :class="data.titleClassName"
      v-html="regionsHtml.title"
    />
    <div v-if="products.length" :class="data.productsClassName">
      <BaseLink
        v-for="(product, index) in products"
        :key="`${data.productsClassName}-product-${index}`"
        :class="data.imageClassName"
        :url="product.link"
      >
        <BaseImage
          :src="product.image"
          :alt="product.name"
          @load="handleImageLoad(product, index)"
          @image-click="emitAnalyticsData(product, index)"
        />
      </BaseLink>
    </div>
    <BaseProductSlider
      v-else-if="sliderProducts.length"
      :products="sliderProducts"
      :wrap-items="data.layout === 'grid'"
      :show-scrollbar="data.layout === 'slider'"
      :hide-product-names="data.hideNames"
      :hide-prices="data.hidePrices"
      :hide-quick-shop="data.hideQuickShop"
      :tile-context="homeRecommendedEinsteinProducts"
      :is-recommendation-from-einstein="isRecommendationFromEinstein"
      :recommender-name="data.recommenderName"
    />
  </div>
</template>

<script>
import getFrontConfig from '../../common/getFrontConfig';
import BaseImage from './BaseImage.vue';
import BaseLink from './BaseLink.vue';
import BaseProductSlider from './BaseProductSlider.vue';
import bemClassesMixin from '../mixins/bemClassesMixin';
import EventBusConfig from '../config/eventBusConfig';
import pageDesignerMixin from '../mixins/pageDesignerMixin';

const {
  vue: {
    BaseProductTile: {
      context: { homeRecommendedEinsteinProducts },
    },
  },
} = getFrontConfig();

export default {
  name: 'ThePageComponentRecommendedProducts',

  components: {
    BaseImage,
    BaseLink,
    BaseProductSlider,
  },

  mixins: [bemClassesMixin, pageDesignerMixin],

  props: {
    isRecommendationFromEinstein: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      products: [],
      homeRecommendedEinsteinProducts,
      isLoaded: false,
      sliderProducts: [],
    };
  },

  computed: {
    /**
     * While the recommendations are in flight the component keeps its place
     * (the simple layout renders placeholders there). Once they arrive with
     * nothing to show, the whole module is dropped so the title does not stay
     * on its own.
     * @returns {boolean} whether the component should be rendered
     */
    hasSomethingToShow() {
      return (
        !this.isLoaded ||
        this.products.length > 0 ||
        this.sliderProducts.length > 0
      );
    },
    isSimpleLayout() {
      return !this.data?.layout || this.data.layout === 'simple';
    },
  },

  created() {
    if (
      this.isSimpleLayout &&
      this.data?.maxProductsToShow &&
      this.data?.urlGetProducts
    ) {
      // generar placeholders
      for (let i = 0; i < this.data?.maxProductsToShow; i++) {
        this.products.push({
          name: '',
          image: null,
          link: null,
          pid: null,
        });
      }
    } else if (this.data?.products?.products) {
      this.products = this.data.products.products;
    }
  },

  mounted() {
    this.setProductsInfo();
  },

  methods: {
    handleImageLoad(product, index) {
      this.emitAnalyticsData(
        product,
        index,
        EventBusConfig.events.TheSearchModal.recommendedProductViewed
      );
    },
    setProductsInfo() {
      if (!this.data?.urlGetProducts) return;
      fetch(this.data.urlGetProducts)
        .then((res) => res.json())
        .then(({ recommendations = [] }) => {
          if (this.isSimpleLayout) {
            this.products =
              recommendations?.map(({ product }) => product) || [];
          } else {
            this.sliderProducts = recommendations || [];
          }
        })
        .catch(() => {
          this.products = [];
          this.sliderProducts = [];
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
    emitAnalyticsData(product, index, eventName = null) {
      if (!product?.pid) return;
      this.$eventBus.$emit(
        eventName ||
          EventBusConfig.events.TheSearchModal.recommendedProductClicked,
        {
          product,
          index,
          componentType: this.data.componentType,
          recommender: {
            name: this.data.recommenderName,
            isEinstein: this.isRecommendationFromEinstein,
          },
        }
      );
    },
  },
};
</script>
